<template>
  <div class="modules">
    <!-- 除首页外的左边导航栏 -->
    <div class="LeftNav">
      <div class="leftNav-name text-center">
        <div class="Navigation">导航</div>
      </div>
      <div class="leftNav-navs">
        <div class="leftNav-nav" @click="goTo('sy')">
          <div class="text-center"><span>首页</span></div>
        </div>
        <div class="leftNav-nav" @click="goTo('gcgd')">
          <div class="text-center"><span>工程工队</span></div>
        </div>
        <div class="leftNav-nav" @click="goTo('lsyg')">
          <div class="text-center"><span>临时用工</span></div>
        </div>
        <div class="leftNav-nav" @click="goTo('gzbj')">
          <div class="text-center"><span>工种报价</span></div>
        </div>
        <div class="leftNav-nav" @click="goTo('lwyg')">
          <div class="text-center"><span>劳务用工</span></div>
        </div>
        <div class="leftNav-nav" @click="goTo('zygr')">
          <div class="text-center"><span>专业工人</span></div>
        </div>
        <div class="leftNav-nav" @click="goTo('gcfb')">
          <div class="text-center"><span>工程分包</span></div>
        </div>
        <div class="leftNav-nav" @click="goTo('lwgs')">
          <div class="text-center"><span>劳务公司</span></div>
        </div>
        <div class="leftNav-nav" @click="goTo('rqgd')">
          <div class="text-center"><span>人气工队</span></div>
        </div>
      </div>
      <div  class="leftNav-top" @click="scrollTop">
          <div class="text-centers">回顶部</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "leftNav",
  data() {
    return {
    }
  },
  components: {
  },
  mounted() {
  },
  methods: {
    //去列表
    goTo(name){
      let routeUrl=''
      if(name=='gcfb'){
        routeUrl = `/zb`;
      }else if(name=='lwgs'){
        routeUrl = `/LaborServiceCompany`;
      }else if(name=='rqgd'){
        routeUrl=`/popularityTeam`
      }else if(name=='sy'){
        routeUrl=`/`
      }else if(name=='gcgd'){
        routeUrl=`/teamList`
      }else if(name=='lsyg'){
        routeUrl=`/FlexibleEmployment`
      }else if(name=='gzbj'){
        routeUrl=`/volunteerTeamOffer`
        }else if(name=='lwyg'){
        routeUrl=`/labour`
      }else if(name=='zygr'){
        routeUrl=`/worker`
      }
      this.$router.push(routeUrl)
    },
    // 滑动到顶部
    scrollTop() {
      // 加入定时器让他又快到慢滚动到顶部
      let timer = setInterval(() => {
        // 获取当前scrollTop的高度位置（兼容ie和chrom浏览器）
        let oTop = document.documentElement.scrollTop || document.body.scrollTop
        // 设置速度由快到慢
        let ispeed = Math.floor(-oTop / 3)
        document.documentElement.scrollTop = document.body.scrollTop =
          oTop + ispeed
        if (oTop === 0) {
          clearInterval(timer)
        }
      }, 30)
    },
  },
}
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.LeftNav {
    position: fixed;
    top: 200px;
    left: 50%;
    width: 60px;
    -webkit-transform: translateX(-680px);
    transform: translateX(-680px);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff!important;
  .text-center{
    position: relative;
    span {
    position: absolute;
    width: 2em;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    }
  }
  .leftNav-name{
    height: 61px;
    background:url("../../../assets/sidebar/daohang-lefts.png") 15px 7px no-repeat;
    background-size: 30px 30px;
    background-color: #df361b;
    border-bottom: 1px solid #fff;
    .Navigation{
      padding-top:36px;
      text-align:center;
      font-size: 12px;
    }
  }
  .leftNav-navs {
    background: #999;
    .leftNav-nav {
      border-width: 15px;
      padding: 0 ;
      cursor: pointer;
      &:hover{
        background-color: #b79255;
      }
    }
    .leftNav-nav>div{
      width: 100%;
      height: 60px;
      border-bottom: 1px solid #fff;
    }
  }
  .leftNav-top {
    height: 61px;
    width: 100%;
    background:url("../../../assets/sidebar/tops.png") 13px 12px no-repeat;
    background-size: 32px 20px;
    background-color: #ccc;
    cursor: pointer;
    .text-centers{
    text-align: center;
    padding-top: 33px;
    font-size: 13px;
  }
  }
}
@media screen and (max-height: 900px) {
  .LeftNav {
    position: fixed;
    top: 200px;
    // left: calc(50% + 10px);
    width: 52px;
    -webkit-transform: translateX(-680px);
    transform: translateX(-680px);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff!important;
  .text-center{
    position: relative;
    span {
    position: absolute;
    width: 2em;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    }
  }
  .leftNav-name{
    height: 52px;
    background:url("../../../assets/sidebar/daohang-lefts.png") 13px 5px no-repeat;
    background-size: 25px 25px;
    background-color: #df361b;
    border-bottom: 1px solid #fff;
    .Navigation{
      padding-top:30px;
      text-align:center;
      font-size: 12px;
    }
  }
  .leftNav-navs {
    background: #999;
    .leftNav-nav {
      border-width: 15px;
      padding: 0 ;
      cursor: pointer;
      &:hover{
        background-color: #b79255;
      }
    }
    .leftNav-nav>div{
      width: 100%;
      height: 52px;
      border-bottom: 1px solid #fff;
    }
  }
  .leftNav-top {
    height: 52px;
    width: 100%;
    background:url("../../../assets/sidebar/tops.png") 10px 6px no-repeat;
    background-size: 32px 20px;
    background-color: #ccc;
    cursor: pointer;
    .text-centers{
    text-align: center;
    padding-top: 28px;
    font-size: 13px;
  }
  }
}
}
</style>
